import React from 'react'
import styles from './warning-message.styles'
import injectSheet from 'react-jss'

const WarningMessage = ({ classes, children }) => (
  <p className={classes.message}>{children}</p>
)

export default injectSheet(styles)(WarningMessage)
